module.exports = __webpack_public_path__ + "static/img/img_home_ryj.789d5d63.png";